import { useNavigate, useLocation } from 'react-router'

export default function NotFound({ status = 404 }: { status?: number }) {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', gap: 0, textAlign: 'center', padding: '0 24px',
    }}>
      <div className="mono" style={{ fontSize: 96, fontWeight: 700, color: 'var(--line)', lineHeight: 1, letterSpacing: '-0.04em', marginBottom: 24 }}>
        {status}
      </div>
      <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 12 }}>
        {status === 404 ? 'Page not found.' : 'Something went wrong.'}
      </h1>
      <p style={{ fontSize: 14, color: 'var(--fg-3)', maxWidth: 380, lineHeight: 1.6, marginBottom: 32 }}>
        {status === 404
          ? <>
              <code className="mono" style={{ fontSize: 12, color: 'var(--fg-2)', background: 'var(--bg-2)', padding: '2px 6px', borderRadius: 4 }}>
                {pathname}
              </code>
              {' '}doesn't exist. If you're looking for a grid, make sure the URL includes both a handle and a slug.
            </>
          : 'An unexpected error occurred. Try reloading, or go back home.'}
      </p>
      <div style={{ display: 'flex', gap: 10 }}>
        <button className="btn btn-ghost btn-mono" onClick={() => navigate(-1)}>← Go back</button>
        <button className="btn btn-primary" onClick={() => navigate('/')}>Home</button>
      </div>
    </div>
  )
}
